import { useAuthContext } from '../context/KeyCloakAuthProvider';

export const useAuthUser = () => {
  const { user, isAuthenticated } = useAuthContext();

  return {
    isAuthenticated,
    user,
  };
};

export const useAuthMethod = () => {
  const { saveAuth, logout } = useAuthContext();

  return {
    saveAuth,
    logout,
  };
};
